document.addEventListener('DOMContentLoaded', () => {
  const bannerSliders = document.querySelectorAll('.custom-banner-slider');
  const countdownSection = document.querySelector('.countdown-timer-section');

  if (!bannerSliders.length || !countdownSection) return;

  const observer = new IntersectionObserver(
    (entries) => {
      // If ANY banner is visible, don't activate
      const anyVisible = entries.some(entry => entry.isIntersecting);

      if (anyVisible) {
        countdownSection.classList.remove('active');
      } else {
        countdownSection.classList.add('active');
      }
    },
    { threshold: 0 }
  );

  bannerSliders.forEach(slider => observer.observe(slider));
});

